var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DDAE80E5-A541-41AA-BB1A-5ACECD0398F3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.70710678,0.292893219 L12,10.585 L22.2928932,0.292893219 C22.6533772,-0.0675907428 23.2206082,-0.0953202783 23.6128994,0.209704612 L23.7071068,0.292893219 C24.0976311,0.683417511 24.0976311,1.31658249 23.7071068,1.70710678 L23.7071068,1.70710678 L13.415,12 L23.7071068,22.2928932 C24.0976311,22.6834175 24.0976311,23.3165825 23.7071068,23.7071068 C23.3165825,24.0976311 22.6834175,24.0976311 22.2928932,23.7071068 L12,13.415 L1.70710678,23.7071068 C1.34662282,24.0675907 0.779391764,24.0953203 0.387100557,23.7902954 L0.292893219,23.7071068 C-0.0976310729,23.3165825 -0.0976310729,22.6834175 0.292893219,22.2928932 L0.292893219,22.2928932 L10.585,12 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "------Search-Bar-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Global-Owner-/-Search-Bar",
    transform: "translate(-1381.000000, -126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-Term",
    transform: "translate(0.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1381.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icons-/-Close",
    fill: "#00095B",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.165a9fdb5378288756798a486d84a19a.svg";
export { ForwardRef as ReactComponent };